import type { FC, ReactNode } from 'react'
import { H3, H5, spacing, useIsMobileVariant } from '@dhl-ui/components'

type PageTitleProps = {
  title: ReactNode
}

/**
 * Page title for all variants
 * for mobile variant meant for full width content page
 */
export const PageTitleAllVariants: FC<PageTitleProps> = ({ title }) => {
  const isMobileVariant = useIsMobileVariant()

  if (isMobileVariant) {
    return <H5 sx={{ m: spacing(0, 2) }}>{title}</H5>
  }

  return <H3>{title}</H3>
}
